export default __webpack_public_path__ + "static/media/makara.5c1e18ba.svg";